import { cond, identity, negate, pipe, tap } from 'lodash/fp';

import {
  app,
} from './initializeApp';

import {
  getAuth,
  onAuthStateChanged,
  signInAnonymously,
} from 'firebase/auth';

const auth = getAuth(app);

export function ensureUser()
{
  return new Promise(resolve => {
    const unsubscribe = onAuthStateChanged
    (
      auth,
      pipe
      ([
        tap(cond([[negate(identity), () => signInAnonymously(auth)]])),
        tap(cond([[identity, () => unsubscribe()]])),
        tap(cond([[identity, () => resolve()]])),
      ])
    );
  });
}